/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const doneBoxStyle = {
  box: {
    padding: "0.25rem 1rem 1rem",
  },
  documentBox: {
    padding: "0.25rem 1rem 1rem",
  },
  boxHeading: {
    color: "primary.main",
    fontWeight: 500,
    textAlign: "center",
  },
  boxText: {
    maxWidth: "650px",
    margin: "0 auto",
    textAlign: "center",
  },
  boxHeadingData: {
    textAlign: "center",
    color: "primary.main",
  },
  subheader: {
    marginTop: "40px",
  },
  divider: {
    backgroundColor: "#cdcdcd",
    width: "100%",
    height: "1px",
    margin: "10px 0",
  },
  label: {
    fontWeight: 400,
    paddingTop: "16px",
  },
  buttonShowMore: {
    float: "right",
    marginTop: "20px",
    padding: "8px",
  },
  // Grid Image List
  gridImage: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
  },
  documentContainer: {
    position: "relative",
  },
  titleBar: {
    position: "absolute",
    bottom: "7px",
    left: 0,
    right: 0,
    background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, " + "rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
    display: "flex",
  },
  icon: {
    color: "white",
    width: "40px",
    height: "40px",
    margin: "8px",
  },
  description: {
    color: "#fff",
    fontWeight: 400,
    textAlign: "center",
    padding: "0.5rem",
  },
  headlineContainer: {
    margin: "2rem 0 2rem 0",
    justifyContent: "center",
  },
};

export default doneBoxStyle;
